import { uniq } from "lodash-es";

import type {
  DictsysEnglishNounInflectionScheme,
  DictsysInflectionSchemeCell,
  DictsysInflectionSchemeContent,
  DictsysInflectionSchemeTable
} from "@/types";

function getBodyCell(input?: DictsysInflectionSchemeContent[]): DictsysInflectionSchemeCell {
  const cell: DictsysInflectionSchemeCell = { type: "body", elements: [{ texts: ["-"] }] };

  if (input === undefined || input.length === 0) {
    return { type: "body", elements: [{ comment: "findes ikke" }] };
  }

  const uniqueInflections = uniq(input.map((content) => content.inflexion + content.suffix));

  if (uniqueInflections.length === 0) {
    return cell;
  }

  cell.elements = uniqueInflections.map((text) => ({ texts: [text] }));
  return cell;
}

export function getTable(inflectionScheme: DictsysEnglishNounInflectionScheme): DictsysInflectionSchemeTable | null {
  if (!inflectionScheme.noun) {
    return null;
  }

  const indefinite = inflectionScheme.noun.common.indefinite;

  return {
    cells: [
      [
        { type: "sub-header", elements: [] },
        { type: "sub-header", elements: [] },
        { type: "sub-header", elements: [{ texts: ["Genitiv"], comment: "(ejefald)" }] }
      ],
      [
        { type: "sub-header", elements: [{ texts: ["Singularis"], comment: "(ental)" }] },
        getBodyCell(indefinite.singular),
        getBodyCell(indefinite.genitive.singular)
      ],
      [
        { type: "sub-header", elements: [{ texts: ["Pluralis"], comment: "(flertal)" }] },
        getBodyCell(indefinite.plural),
        getBodyCell(indefinite.genitive.plural)
      ]
    ]
  };
}
